let loaded = new Set();

function addStylesheet(href: string) {
  if (loaded.has(href)) {
    return;
  }
  let link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = href;
  if (document.head) {
    document.head.appendChild(link);
  }
  loaded.add(href);
}

export default addStylesheet;
